/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Button, Box, Layer, Heading, BoxProps } from 'grommet';

import { NavBar } from './NavBar';
import { navbarHeight } from 'blb-styles/constants';

export namespace FullScreenModal {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    // override actions, if you need to add multiple buttons.
    actionsComponent?: React.ReactNode;
    bodyPropsOverride?: BoxProps;
    children?: React.ReactNode;
    handleClose: (event: React.SyntheticEvent<any>) => void;
    subtitleComponent?: React.ReactNode;
    title: string;
  }
}

export const FullScreenModal: React.FC<FullScreenModal.Props> = ({
  children,
  actionsComponent,
  handleClose,
  title,
  subtitleComponent,
  bodyPropsOverride,
  ...htmlProps
}) => {
  const { id } = htmlProps;
  return (
    <Box background="white" height="100vh" width="100wh" {...htmlProps}>
      <Layer>
        <Box height="100vh" width="100vw">
          <NavBar>
            <Heading color="night" id={`${id}-title`} level="1" size="xsmall">
              {title}
              {subtitleComponent}
            </Heading>
            <Box direction="row">
              <Button
                data-track-element-name="FullScreenModalCloseBtn"
                id={`${id}-closeBtn`}
                label="Close"
                margin="xxsmall"
                onClick={handleClose}
                secondary
                size="medium"
              />
              {actionsComponent}
            </Box>
          </NavBar>
          <Box
            align="center"
            height={`calc(100vh - ${navbarHeight})`}
            id={`${id}-scroller`}
            overflow="scroll"
            width="100vw"
            {...bodyPropsOverride}
          >
            {children}
          </Box>
        </Box>
      </Layer>
    </Box>
  );
};
